import { addons } from '@storybook/addons';
import s2a from './s2a-theming/s2a.main';

addons.setConfig({
  theme: s2a,
});
